@if (i18n.translations$ | async; as translations) {

<main class="page">
  <div class="form-card">

    <!-- TITLE -->
    <h1 class="title">
      {{ i18n.t(translations, 'register.title') }}
    </h1>

    <!-- SUBTITLE -->
    <div class="subtitle">
      <p>
        {{ i18n.t(translations, 'register.alreadyAccount') }}
        <a [href]="portalLoginUrl +'?lang=' + i18n.t(translations, 'language.localeCode')">
          {{ i18n.t(translations, 'register.loginHere') }}
        </a>
      </p>

      <p>
        {{ i18n.t(translations, 'register.troubleAccess') }}
        <a [href]="contactUsUrl + '?lang=' + i18n.t(translations, 'language.localeCode')" target="_blank"
          rel="noopener noreferrer">
          {{ i18n.t(translations, 'register.contactUs') }}
        </a>
      </p>
    </div>

    <!-- FORM -->
    <form class="account-form" [formGroup]="form" (ngSubmit)="submit()">

      <!-- PERSONAL INFO -->
      <div class="grid">

        <app-inputfields controlId="control_name" [label]="i18n.t(translations, 'register.firstName')"
          [placeholder]="i18n.t(translations, 'placeholders.firstName')" [control]="form.controls['name']"
          [required]="true" [maxLength]="40">
        </app-inputfields>

        <app-inputfields controlId="control_surname" [label]="i18n.t(translations, 'register.lastName')"
          [placeholder]="i18n.t(translations, 'placeholders.lastName')" [control]="form.controls['surname']"
          [required]="true" [maxLength]="40">
        </app-inputfields>

        <app-selectfields controlId="selSalutation" [label]="i18n.t(translations, 'register.salutation')"
          [placeholder]="i18n.t(translations, 'register.select')" [control]="form.controls.salutation"
          [options]="salutations" [required]="true">
        </app-selectfields>

        <app-inputfields controlId="control_dob" type="date" [label]="i18n.t(translations, 'register.dob')"
          [control]="form.controls['dob']" [required]="true">
        </app-inputfields>

        <app-selectfields controlId="selCountryOfBirth" [label]="i18n.t(translations, 'register.countryOfBirth')"
          [placeholder]="i18n.t(translations, 'register.select')" [control]="form.controls.countryOfBirth"
          [options]="countries" [required]="true">
        </app-selectfields>

        <app-inputfields controlId="control_placeOfBirth" [label]="i18n.t(translations, 'register.placeOfBirth')"
          [control]="form.controls['placeOfBirth']" [required]="true" [maxLength]="255">
        </app-inputfields>

        <app-selectfields controlId="selPreferredLanguage" [label]="i18n.t(translations, 'register.preferredLanguage')"
          [placeholder]="i18n.t(translations, 'register.select')" [control]="form.controls.language"
          [options]="languages" [required]="true">
        </app-selectfields>

      </div>

      <!-- WARNING -->
      <div class="warning">

        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_729_982)">
            <path
              d="M12 6.5C12.5523 6.5 13 6.94772 13 7.5L13 13.5C13 14.0523 12.5523 14.5 12 14.5C11.4477 14.5 11 14.0523 11 13.5L11 7.5C11 6.94772 11.4477 6.5 12 6.5Z"
              fill="#FF9F1A" />
            <path
              d="M12 18.5C12.8284 18.5 13.5 17.8284 13.5 17C13.5 16.1716 12.8284 15.5 12 15.5C11.1716 15.5 10.5 16.1716 10.5 17C10.5 17.8284 11.1716 18.5 12 18.5Z"
              fill="#FF9F1A" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M9.82664 2.22902C10.7938 0.590326 13.2063 0.590325 14.1735 2.22902L23.6599 18.3024C24.6578 19.9933 23.3638 22 21.4865 22H2.51362C0.63634 22 -0.657696 19.9933 0.340215 18.3024L9.82664 2.22902ZM12.4511 3.24557C12.2578 2.91814 11.7423 2.91814 11.549 3.24557L2.06261 19.319C1.90904 19.5792 2.07002 20 2.51362 20H21.4865C21.9301 20 22.0911 19.5792 21.9375 19.319L12.4511 3.24557Z"
              fill="#FF9F1A" />
          </g>
          <defs>
            <clipPath id="clip0_729_982">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <div class="warning-header">
          <p class="warning-line">
            <strong>{{ i18n.t(translations, 'register.warningTitle') }}</strong>
            {{ i18n.t(translations, 'register.warningText') }}
          </p>
          <p class="warning-copy">
            {{ i18n.t(translations, 'register.warningNote') }}
          </p>
          <p class="warning-copy">
            {{ i18n.t(translations, 'register.warningLastPrefix') }}
            <a class="warning-link" [href]="contactUsUrl + '?lang=' + i18n.t(translations, 'language.localeCode')"
              target="_blank" rel="noopener noreferrer">
              {{ i18n.t(translations, 'register.warningLastLink') }}
            </a>
          </p>
        </div>

      </div>

      <!-- LOGIN INFO -->
      <div class="grid">

        <app-inputfields controlId="control_email" type="email" [label]="i18n.t(translations, 'register.email')"
          [control]="form.controls['email']" [required]="true">
        </app-inputfields>

        <app-inputfields controlId="control_password" type="password"
          [label]="i18n.t(translations, 'register.password')" [control]="form.controls['password']" [required]="true">
        </app-inputfields>

        @if (!invitationId) {
        <app-inputfields controlId="control_confirmEmail" type="email"
          [label]="i18n.t(translations, 'register.confirmEmail')" [control]="form.controls['confirmEmail']"
          [required]="true">
        </app-inputfields>
        }

        <app-inputfields controlId="control_confirmPassword" type="password"
          [label]="i18n.t(translations, 'register.confirmPassword')" [control]="form.controls['confirmPassword']"
          [required]="true">
        </app-inputfields>

      </div>

      <!-- TERMS -->
      <div class="grid">
        <div class="terms-block">
          <label class="checkbox termsCondition">
            <input type="checkbox" formControlName="terms" />
            {{ i18n.t(translations, 'register.agree') }}
            <a [href]="termsUrl" target="_blank" rel="noopener noreferrer" (click)="onTermsLinkClicked($event)">
              {{ i18n.t(translations, 'register.terms') }}
            </a>
          </label>

          @if (submitted && !form.get('terms')?.value) {
          <p class="error-message">
            {{ i18n.t(translations, 'errors.acceptTerms') }}
          </p>
          }
        </div>

        <app-cloud-fare (tokenGenerated)="onTokenReceived($event)" (tokenInvalid)="onTokenInvalid()">
        </app-cloud-fare>
      </div>

      <!-- ACTION -->
      <div class="actions">
        <button class="btn-primary" type="submit">
          {{ i18n.t(translations, 'register.submit') }}
        </button>

        <p class="privacy-note">
          {{ i18n.t(translations, 'register.privacyPrefix') }}
          <a [href]="privacyUrl" target="_blank" rel="noopener noreferrer">
            {{ i18n.t(translations, 'register.privacyLink') }}
          </a>
        </p>
      </div>

    </form>
  </div>
</main>

}

<!-- GLOBAL -->
<app-loader [visible]="showLoader" (closed)="showLoader = false">
</app-loader>

<app-toaster #toast></app-toaster>